<template>
  <div>
    <button
      :class="{ 'button-item': isSquare }"
      style="width: 100%; position: relative; font-weight: bold"
      :style="{
        color: this.fontColor,
        borderTop: borderTopStyle,
        borderRight: borderRightStyle,
        borderBottom: borderBottomStyle,
        borderLeft: borderLeftStyle,
        boxShadow: boxShadowStyle,
        background: gradationStyle,
        borderRadius: borderRadiusStyle,
      }"
      @click.prevent="() => false"
    >
      <template v-if="labelText">
        <TopLeftQuadrangle v-if="labelType === 'top_left_quadrangle'" :item="item" />
        <Quadrangle v-if="labelType === 'quadrangle'" :item="item" />
        <SpeechBubble v-if="labelType === 'speech_bubble'" :item="item" />
      </template>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 16px 12px;
        "
        :style="{
          fontSize: `${this.fontSize}px`,
          flexDirection: flexColumnStyle,
        }"
      >
        <span v-if="beforeIcon" class="d-block align-self-center">
          <font-awesome-icon :icon="beforeIcon" />
        </span>
        <span
          class="d-block ma-auto"
          style="align-self: center"
          :style="{ padding: paddingStyle }"
        >
          <span style="word-break: break-all; white-space: pre-wrap; line-height: 1.5; letter-spacing: 1px;">{{
            content
          }}</span>
        </span>
        <span v-if="afterIcon" class="d-block align-self-center">
          <font-awesome-icon :icon="afterIcon" />
        </span>
      </div>
    </button>
  </div>
</template>

<script>
import TopLeftQuadrangle from '../labels/TopLeftQuadrangle'
import Quadrangle from '../labels/Quadrangle'
import SpeechBubble from '../labels/SpeechBubble'

export default {
  name: 'BtnLayout',
  components: { SpeechBubble, Quadrangle, TopLeftQuadrangle },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSquare () {
      return this.item.itemableAttributes.type === 'square'
    },
    fontColor () {
      return this.item.itemableAttributes.fontColor
    },
    backgroundColor () {
      return this.item.itemableAttributes.backgroundColor
    },
    fontSize () {
      return this.item.itemableAttributes.fontSize
    },
    borderTopStyle () {
      if (
        this.item.itemableAttributes.border &&
        this.item.itemableAttributes.border.top
      ) {
        return `${this.item.itemableAttributes.border.top.size}px solid ${this.item.itemableAttributes.border.top.color}`
      }
      return ''
    },
    borderRightStyle () {
      if (
        this.item.itemableAttributes.border &&
        this.item.itemableAttributes.border.right
      ) {
        return `${this.item.itemableAttributes.border.right.size}px solid ${this.item.itemableAttributes.border.right.color}`
      }
      return ''
    },
    borderLeftStyle () {
      if (
        this.item.itemableAttributes.border &&
        this.item.itemableAttributes.border.left
      ) {
        return `${this.item.itemableAttributes.border.left.size}px solid ${this.item.itemableAttributes.border.left.color}`
      }
      return ''
    },
    borderBottomStyle () {
      if (
        this.item.itemableAttributes.border &&
        this.item.itemableAttributes.border.bottom
      ) {
        return `${this.item.itemableAttributes.border.bottom.size}px solid ${this.item.itemableAttributes.border.bottom.color}`
      }
      return ''
    },
    boxShadowStyle () {
      if (this.item.itemableAttributes.boxShadow) {
        return `${this.item.itemableAttributes.boxShadow.x}px ${this.item.itemableAttributes.boxShadow.y}px ${this.item.itemableAttributes.boxShadow.blur}px ${this.item.itemableAttributes.boxShadow.spread}px rgba(0,0,0,.3)`
      }
      return ''
    },
    paddingStyle () {
      if (this.item.itemableAttributes.padding) {
        return `${this.item.itemableAttributes.padding.y || 0}px ${
          this.item.itemableAttributes.padding.x || 0
        }px`
      }
      return '0 0'
    },
    borderRadiusStyle () {
      if (this.item.itemableAttributes.radius) {
        return this.item.itemableAttributes.radius
      }
      return '0'
    },
    flexColumnStyle () {
      if (this.item.itemableAttributes.flexColumn) {
        return 'column'
      }
      return 'row'
    },
    gradationStyle () {
      if (this.item.itemableAttributes.gradientColor) {
        return `linear-gradient(to bottom, ${this.item.itemableAttributes.backgroundColor} 0%, ${this.item.itemableAttributes.gradientColor} 100%)`
      }
      return this.item.itemableAttributes.backgroundColor
    },
    beforeIcon () {
      return this.item.itemableAttributes.beforeIcon
    },
    afterIcon () {
      return this.item.itemableAttributes.afterIcon
    },
    content () {
      return this.item.itemableAttributes.content
    },
    labelType () {
      return this.item.itemableAttributes.labelType
    },
    labelText () {
      return this.item.itemableAttributes.labelText
    }
  }
}
</script>

<style scoped>
.button-item::before {
  content: '';
  display: block;
  padding-top: 100%;
}
.button-item {
  display: inline-block;
  position: relative;
  margin: auto;
  min-width: 100px;
}
.button-item div {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
</style>
